const getThreadActiveRunIdValue = ({ threadContentValue, threadMetaValue }) => {
  return String(threadContentValue?.runState?.runId || threadMetaValue?.runState?.runId || '').trim() || null;
};

export default getThreadActiveRunIdValue;
